module.exports = __webpack_public_path__ + "static/img/Nutriologa.38cec6d9.webp";